import './Table.css';

function Table({ columns, rows, rowKey = 'id', emptyMessage = 'Aucune donnée.', renderActions, sortKey, sortDir, onSort }) {
  if (!rows || rows.length === 0) {
    return <p className="admin-table-empty">{emptyMessage}</p>;
  }

  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map((col) =>
              col.sortable ? (
                <th key={col.key}>
                  <button type="button" className="admin-table-sort-btn" onClick={() => onSort(col.key)}>
                    {col.label}
                    <span className="admin-table-sort-icon">
                      {sortKey === col.key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
                    </span>
                  </button>
                </th>
              ) : (
                <th key={col.key}>{col.label}</th>
              )
            )}
            {renderActions && <th />}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row[rowKey]}>
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
              ))}
              {renderActions && <td className="admin-table-actions">{renderActions(row)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
